export const TASKS = {
    AssignLinkedEntities() {
        return import(
            /* webpackChunkName: "AssignLinkedEntities" */ "@arachnys/catalog/assign_linked_entities/react/AssignLinkedEntities.js"
        ).then(({ AssignLinkedEntities }) => AssignLinkedEntities);
    },
    AutoClosePending() {
        return import(
            /* webpackChunkName: "AutoClosePending" */ "@arachnys/catalog/auto_close_pending/frontend/AutoClosePending"
        ).then(({ AutoClosePending }) => AutoClosePending);
    },
    Confirmation() {
        return import(
            /* webpackChunkName: "Confirmation" */ "@arachnys/catalog/confirmation_task/react/Confirmation.js"
        ).then(({ Confirmation }) => Confirmation);
    },
    EnrichRequest() {
        return import(
            /* webpackChunkName: "EnrichRequest" */ "@arachnys/catalog/enrich_request/react/EnrichRequest.js"
        ).then(({ EnrichRequest }) => EnrichRequest);
    },
    CorrectEnrichEntity() {
        return import(
            /* webpackChunkName: "CorrectEnrichEntity" */ "@arachnys/catalog/correct_enrich_entity/react/CorrectEnrichEntity.js"
        ).then(({ CorrectEnrichEntity }) => CorrectEnrichEntity);
    },
    DispositionInHeimdall() {
        return import(
            /* webpackChunkName: "DispositionInHeimdall" */ "@arachnys/catalog/disposition_in_heimdall/react/DispositionInHeimdall.js"
        ).then(({ DispositionInHeimdall }) => DispositionInHeimdall);
    },
    DispositionResults() {
        return import(
            /* webpackChunkName: "DispositionResults" */ "@arachnys/catalog/disposition_results/react/DispositionResults.js"
        ).then(({ DispositionResults }) => DispositionResults);
    },
    DispositionResultsV2() {
        return import(
            /* webpackChunkName: "DispositionResultsV2" */ "@arachnys/catalog/disposition_results_v2/react/DispositionResultsV2.js"
        ).then(({ DispositionResultsV2 }) => DispositionResultsV2);
    },
    JSONSchemaForm() {
        return import(
            /* webpackChunkName: "JSONSchemaForm" */ "@arachnys/catalog/json_schema_form/react/JSONSchemaForm.js"
        ).then(({ JSONSchemaForm }) => JSONSchemaForm);
    },
    MergeEntityWithState() {
        return import(
            /* webpackChunkName: "MergeEntityWithState" */ "@arachnys/catalog/merge_entity_with_state/react/MergeEntityWithState.js"
        ).then(({ MergeEntityWithState }) => MergeEntityWithState);
    },
    MergeEntity() {
        return import(
            /* webpackChunkName: "MergeEntity" */ "@arachnys/catalog/merge_entity/react/MergeEntity.js"
        ).then(({ MergeEntity }) => MergeEntity);
    },
    MergeEntityV2() {
        return import(
            /* webpackChunkName: "MergeEntityV2" */ "@arachnys/catalog/merge_entity_v2/react/MergeEntityV2.js"
        ).then(({ MergeEntityV2 }) => MergeEntityV2);
    },
    MergeSelectEntity() {
        return import(
            /* webpackChunkName: "MergeSelectEntity" */ "@arachnys/catalog/merge_select_entity/react/MergeSelectEntity.js"
        ).then(({ MergeSelectEntity }) => MergeSelectEntity);
    },
    ProcessSummary() {
        return import(
            /* webpackChunkName: "ProcessSummary" */ "@arachnys/catalog/process_summary/react/ProcessSummary.js"
        ).then(({ ProcessSummary }) => ProcessSummary);
    },
    ProjectInD3() {
        return import(
            /* webpackChunkName: "ProjectInD3" */ "@arachnys/catalog/project_in_d3/react/ProjectInD3.js"
        ).then(({ ProjectInD3 }) => ProjectInD3);
    },
    NavigatorResearch() {
        return import(
            /* webpackChunkName: "NavigatorResearch" */ "@arachnys/catalog/navigator_research/react/NavigatorResearch.js"
        ).then(({ NavigatorResearch }) => NavigatorResearch);
    },
    ReviewHeimdallResults() {
        return import(
            /* webpackChunkName: "ReviewHeimdallResults" */ "@arachnys/catalog/review_heimdall_results/react/ReviewHeimdallResults.js"
        ).then(({ ReviewHeimdallResults }) => ReviewHeimdallResults);
    },
    SearchCorporateRegistry() {
        return import(
            /* webpackChunkName: "SearchCorporateRegistry" */ "@arachnys/catalog/search_corporate_registry/react/SearchCorporateRegistry.js"
        ).then(({ SearchCorporateRegistry }) => SearchCorporateRegistry);
    },
    SearchUda() {
        return import(
            /* webpackChunkName: "SearchUda" */ "@arachnys/catalog/search_uda/react/SearchUda.js"
        ).then(({ SearchUda }) => SearchUda);
    },
    SelectEntity() {
        return import(
            /* webpackChunkName: "SelectEntity" */ "@arachnys/catalog/select_entity/react/SelectEntity.js"
        ).then(({ SelectEntity }) => SelectEntity);
    },
    SelectSingleSearchResult() {
        return import(
            /* webpackChunkName: "SelectSingleSearchResult" */ "@arachnys/catalog/select_single_search_result/react/SelectSingleSearchResult.js"
        ).then(({ SelectSingleSearchResult }) => SelectSingleSearchResult);
    },
    SelectSource() {
        return import(
            /* webpackChunkName: "SelectSource" */ "@arachnys/catalog/select_source/react/SelectSource.js"
        ).then(({ SelectSource }) => SelectSource);
    },
    SubmitRelatedEntities() {
        return import(
            /* webpackChunkName: "SubmitRelatedEntities" */ "@arachnys/catalog/submit_related_entities/react/SubmitRelatedEntities.js"
        ).then(({ SubmitRelatedEntities }) => SubmitRelatedEntities);
    },
    UpdateSingleEntityRelation() {
        return import(
            /* webpackChunkName: "UpdateSingleEntityRelation" */ "@arachnys/catalog/update_single_entity_relation/react/UpdateSingleEntityRelation.js"
        ).then(({ UpdateSingleEntityRelation }) => UpdateSingleEntityRelation);
    },
    ViewEntitySummary() {
        return import(
            /* webpackChunkName: "ViewEntitySummary" */ "@arachnys/catalog/view_entity_summary/react/ViewEntitySummary.js"
        ).then(({ ViewEntitySummary }) => ViewEntitySummary);
    },
    ViewEntityUBO() {
        return import(
            /* webpackChunkName: "ViewEntityUBO" */ "@arachnys/catalog/view_entity_ubo/react/ViewEntityUBO.js"
        ).then(({ ViewEntityUBO }) => ViewEntityUBO);
    },
    RedirectAndContinue() {
        return import(
            /* webpackChunkName: "RedirectAndContinue" */ "@arachnys/catalog/redirect_and_continue/react/RedirectAndContinue.js"
        ).then(({ RedirectAndContinue }) => RedirectAndContinue);
    },
    ViewFailure() {
        return import(
            /* webpackChunkName: "ViewFailure" */ "@arachnys/catalog/view_failure/react"
        ).then(({ ViewFailure }) => ViewFailure);
    },
    ViewWarning() {
        return import(
            /* webpackChunkName: "ViewWarning" */ "@arachnys/catalog/view_warning/react"
        ).then(({ ViewWarning }) => ViewWarning);
    },
};
